import './ChangeLogTablesList.scss';

import React, { memo } from 'react';

import bem from '../../../utils/bem';
import { ChangeLogTable } from '../ChangeLogTable';
import type { TargetingChanges, Toggles } from '../hooks/types';
import type { ChangeLogTableProps, DefaultAudit } from '../types';
import { getChangesLengthWithoutDuplicates } from '../utils';

const [block] = bem('change-log-tables-list');

type Props = {
  tablesProps?: ChangeLogTableProps[];
  creativeTablesProps?: DefaultAudit;
  targetingChanges?: TargetingChanges;
  creativeDateFormat?: string;
  creativeModifiedBy?: string;
  toggles?: Toggles[];
  index?: number;
  toggleAt?: (index: number, value: boolean | boolean[]) => void;
};

const ChangeLogTablesList = ({
  tablesProps,
  targetingChanges,
  creativeTablesProps,
  creativeDateFormat,
  creativeModifiedBy,
  toggles,
  index: parentIndex,
  toggleAt,
}: Props): JSX.Element => {
  return (
    <div className={block()} data-testid="change-log-tables-list">
      {tablesProps?.map((props, index) => {
        const changesLength = getChangesLengthWithoutDuplicates(props.changes);
        return changesLength ? (
          <ChangeLogTable
            key={index}
            {...props}
            targetingChanges={targetingChanges}
            creativeTablesProps={creativeTablesProps}
            creativeDateFormat={creativeDateFormat}
            creativeModifiedBy={creativeModifiedBy}
            parentIndex={parentIndex}
            toggles={toggles}
            toggleAt={toggleAt}
          />
        ) : null;
      })}
    </div>
  );
};

export default memo(ChangeLogTablesList);
